import { useState } from 'react';
import { useLocation, Navigate, Outlet } from 'react-router-dom';
import { useSubscription } from '@apollo/client';
import { useAuthStore, useUserStore } from '../../stores';
import { RIDE_CANCELED } from '../../hooks/ride-operations/useRideSubscriptions';
import { playSound } from '../../hooks/useSound';
import RideCanceledModal from '../driver/RideCanceledModal';

function RequireDriverAuth() {
  const { isAuth } = useAuthStore();
  const { userType, userId } = useUserStore();
  const [canceledRider, setCanceledRider] = useState(null);

  const location = useLocation();

  // Global subscription for ride cancellations — shows modal on any driver page
  useSubscription(RIDE_CANCELED, {
    skip: !isAuth || userType !== 'driver',
    onData: ({ data: { data } }) => {
      if (data?.rideCanceled) {
        const { ride, canceledBy } = data.rideCanceled;

        // Only show modal when a rider cancels THIS driver's accepted ride
        if (canceledBy === 'RIDER' && userId === ride.driverId) {
          playSound('alert');
          setCanceledRider(ride.riderName);
        }
      }
    },
  });

  if (!isAuth || userType !== 'driver') {
    return <Navigate to="/unauthorized" state={{ from: location }} replace />;
  }

  return (
    <>
      <Outlet />
      {canceledRider && (
        <RideCanceledModal
          riderName={canceledRider}
          onClose={() => setCanceledRider(null)}
        />
      )}
    </>
  );
}

export default RequireDriverAuth;
